<style>

::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-thumb {
  background: rgba(191, 188, 188, 0.6);
}

.required_err {
  color: rgba(255, 0, 0);
}

.elevation-1 tr:nth-of-type(even) {
    background-color: rgba(0, 0, 0, .03) !important;
}

.br {
    color: rgba(109, 103, 164);
}

</style>

<template>
<div>
    <v-data-table
        :headers="headers"
        :items="items"
        :search="search"
        sort-by="profile_id"
        class="elevation-1"
        @dblclick:row="on_dbl_click">

    <template v-slot:top>
        <v-toolbar flat>
            <v-toolbar-title><h2 class="br">Sysctl variables</h2></v-toolbar-title>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="600px">

            <ValidationObserver ref="observer" v-slot="{ invalid }"><v-card>
                <v-card-title>
                    <span class="headline">{{ edit_caption }}</span>
                </v-card-title>

                <v-card-text>
                    <v-container style="height: 520px; overflow-y: scroll;">
                        <v-row>

                    <v-col cols="12">
                        <ValidationProvider rules="required" v-slot="{ errors }">
                            <v-text-field
                                v-bind:readonly="true"
                                v-model="edited_item.name"
                                label="Name">
                        </v-text-field>
                            <span class="required_err">{{ errors[0] }}</span>
                        </ValidationProvider> 

                        <ValidationProvider rules="required" v-slot="{ errors }">
                            <v-text-field
                                v-bind:readonly="true"
                                v-model="edited_item.scope"
                                label="Scope">
                        </v-text-field>
                            <span class="required_err">{{ errors[0] }}</span>
                        </ValidationProvider>

                        <ValidationProvider v-if="edited_item.numeric == true" rules="required|numeric" v-slot="{ errors }">
                            <v-text-field
                                v-bind:readonly="edited_item.scope === 'startup only'"
                                v-model="edited_item.value"
                                label="Value">
                            </v-text-field>
                            <span class="required_err">{{ errors[0] }}</span>
                        </ValidationProvider>   
                        <ValidationProvider v-else rules="required" v-slot="{ errors }">
                            <v-text-field
                                v-bind:readonly="edited_item.scope === 'startup only'"
                                v-model="edited_item.value"
                                label="Value">
                            </v-text-field>
                            <span class="required_err">{{ errors[0] }}</span>
                        </ValidationProvider>   
                    </v-col>

                        </v-row>
                    </v-container>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1"
                        text @click="close">Cancel</v-btn>
                    <v-btn color="blue darken-1"
                        v-if="edited_item.scope !== 'startup only'"
                        :disabled="invalid" text @click="save">Save</v-btn>
                </v-card-actions>
            </v-card></ValidationObserver>

            </v-dialog>
        </v-toolbar>
    
        <v-toolbar flat>
            <v-text-field v-model="search"
                append-icon="mdi-magnify" label="Search" single-line hide-details
            ></v-text-field>
        </v-toolbar>
    </template>

    <template v-slot:item.actions="{ item }">
        <v-icon small class="me-2" @click="edit_item(item)">
            mdi-pencil
        </v-icon>
    </template>

    <template v-slot:no-data>
    </template>

    </v-data-table>
</div>
</template>
  
<script>

import api_client from '../services/api.js';
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import { ValidationProvider, extend } from 'vee-validate';
import { ValidationObserver } from 'vee-validate';
import { required, numeric } from 'vee-validate/dist/rules';

import "../validation_rules.js";

export default {
name: "sysctl",
components: { 
    Treeselect, ValidationProvider, ValidationObserver,
},
data: () => ({
    edit_caption: '',
    search: '',
    dialog: false,

    headers: [
        { text: 'Name', value: 'name', align: 'start' },
        { text: 'Value', value: 'value' },
        { text: 'Scope', value: 'scope' },
        { text: 'Actions', value: 'actions', sortable: false },
    ],

    items: [],
    edited_index: -1,
    edited_item: {},
}),

watch: {
},

created() {
    this.initialize()
},

methods: {
    calculate_fields() {
        this.items.forEach(item => {
            /*
#define SYSCTL_VT_U32		1	
#define SYSCTL_VT_GENERIC	2
#define SYSCTL_VT_U16		3
#define SYSCTL_VT_U8		4            
            */
            if (item.type === 1 || item.type === 3 || item.type === 4) {
                item["numeric"] = true;
            }
            else {
                item["numeric"] = false;
            }
        });
    },

    initialize() {
        return new Promise((resolve, reject) => {
            api_client.run_get_query('/sysctl/show')
            .then(response => {
                this.items = response.data;
                this.calculate_fields();
                resolve(response);
            })
            .catch(error => {
                console.log(error);
            });
        });
    },

    close() {
        this.dialog = false;
        this.$nextTick(() => {
            this.edited_index = -1;
        });
    },

    edit_item(item) {
        requestAnimationFrame(() => {
            this.$refs.observer.reset();
        });        
        this.edited_index = this.items.indexOf(item);
        this.edited_item = Object.assign({}, item);
        this.edit_caption = 'Edit sysctl variable';
        this.dialog = true;
    },

    on_dbl_click(event, data) {
        this.edit_item(data.item);
    },

    save() {
        let var_value = this.edited_item.value;
        if (this.edited_item.quote === 1) {
            var_value = '"' + var_value + '"';
        }

        api_client.run_post_query('/sysctl/set', {
            var_name: this.edited_item.name,
            value: var_value
        })
        .then(response => {
            if (response.data.hasOwnProperty("err_msg")) {
                this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
            }
            else {
                this.items[this.edited_index].value = this.edited_item.value;
                this.close();
            }
        })
        .catch(error => {
            console.log(error);
            this.$fire({title: "Command failed", text: error, type: "warning"});
        });
    },
}

};
</script>
